export const ADMIN_ROLES_COLLECTION = "adminRoles";

export const SUPER_ADMIN_ROLE_CODE = "SUPER_ADMIN";
export const DEFAULT_ROLE_CODE = "ADMIN";
export const SUPPORT_ROLE_CODE = "SUPPORT";

export const RESERVED_ROLE_CODES = [SUPER_ADMIN_ROLE_CODE] as const;
export type ReservedRoleCode = (typeof RESERVED_ROLE_CODES)[number];

export const ROLE_CODE_REGEX = /^[A-Z][A-Z0-9_]*$/;

export const ADMIN_MODULE_KEYS = [
  "ANALYTICS",
  "KPI_ANALYTICS",
  "USERS",
  "METRICS",
  "GIVEAWAYS",
  "SEASONS",
  "SURVEY",
  "CASH",
  "TESTAMENTS",
  "DISCOUNTS",
  "PROMOS",
  "REDEEM_CODES",
  "PROMOTIONS",
  "CALENDAR",
  "SHOP",
  "ADMIN_USERS",
  "DATA_SECURITY_FRAUD",
  "SETTINGS",
  "TEST",
  "QA_TEST_TOOLS",
] as const;

export type AdminModuleKey = (typeof ADMIN_MODULE_KEYS)[number];

export interface ModulePermission {
  view: boolean;
  edit: boolean;
}

export type AdminRolePermissions = Record<AdminModuleKey, ModulePermission>;

export interface AdminRole {
  role_code: string;
  name: string;
  isDefault: boolean;
  permissions: AdminRolePermissions;
  createdDt: number;
  updatedDt: number;
  createdBy: string;
  createdByEmail: string;
  updatedBy: string;
  updatedByEmail: string;
}
